/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdMaterialsLanguages200,
  GetApiV1ClassroomdisciplineIdMaterialsLanguages401,
  GetApiV1ClassroomdisciplineIdMaterialsLanguages404,
  GetApiV1ClassroomdisciplineIdMaterialsLanguagesPathParams,
  GetApiV1ClassroomdisciplineIdMaterialsLanguagesQueryResponse,
} from "../../types/classPlanningMaterialController/GetApiV1ClassroomdisciplineIdMaterialsLanguages.ts";
import { availableLanguageViewModelSchema } from "../availableLanguageViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdMaterialsLanguagesPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsLanguagesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdMaterialsLanguages200Schema = z.array(
  z.lazy(() => availableLanguageViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsLanguages200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdMaterialsLanguages401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsLanguages401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdMaterialsLanguages404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsLanguages404>;

export const getApiV1ClassroomdisciplineIdMaterialsLanguagesQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdMaterialsLanguages200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsLanguagesQueryResponse>;
